<template>
  <v-layout justify-center>
    <v-btn
      color="primary"
      large
      @click="function(){
        $router.push({ name: 'assets_products' })
      }"
    >
      View Assets & Products Summary
    </v-btn>
  </v-layout>
</template>
<script>
export default {}
</script>